import { ErrorUI } from '@components/organism/common/ErrorUI.jsx'

export const GlobalErrorUI = ({ title, message, buttonLabel, handleClick }) => {
  return (
    <ErrorUI
      title={title}
      message={message}
      buttonLabel={buttonLabel}
      handleClick={handleClick}
      className="min-h-screen justify-center"
    />
  )
}
